import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NouisliderModule } from 'ng2-nouislider';
import { TagInputModule } from 'ngx-chips';
import { ElasticModule } from 'ng-elastic';
import { MaterialModule } from '../app.module';

import { EmbedComponent } from './feed/embed/embed.component';
import { FeedComponent } from './feed/feed.component';
import { FeedCommentsComponent } from './feed/comments/comments.component';
import { FeedAnswerComponent } from './feed/comments/answers/answer.component';
import { ModalContentComponent } from './feed/modal-content/modal-content.component';
import { ModalFeedComponent } from './feed/modal-feed/modal-feed.component';
import { FeedUserComponent } from './feed-user/feed-user.component';
import { FeedVisitorComponent } from './feed-visitor/feed-visitor.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { ListagemCursosComponent } from './listagem-cursos/listagem-cursos.component';
import { ListagemEtapasCursosComponent } from './listagem-etapas-cursos/listagem-etapas-cursos.component';
import { ListagemCursosPaginaComponent } from './listagem-cursos-pagina/listagem-cursos.component';
import { BannerPaginaComponent } from './listagem-cursos-pagina/banner/banner.component';
import { BannerComponent } from './listagem-cursos/banner/banner.component';
import { VisualizadorModule } from '../modules/visualizador/visualizador.module';
import { CursosSugeridosComponent } from './cursos-sugeridos/cursos-sugeridos.component';
import { BannerModule } from '../modules/banner-editor/stage/banner/banner.module';
import { ChatFirebaseComponent } from 'app/@core/components/chat-firebase/chat-firebase.component';
import { SelectUserComponent, SelectUserComponentModal } from './select-user/select-user.component';
import { SelectDialogComponent } from './select-dialog/select-dialog.component';
import { MatMenuModule, MatIconModule, MatFormFieldModule, MatInputModule, MAT_DATE_LOCALE, DateAdapter, MAT_DATE_FORMATS, MatDialogModule, MatSelectModule, MatDatepickerModule, MatAutocompleteModule, MatChipsModule, MatRadioModule, MatCheckboxModule, MatSnackBarModule } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { NgxMaskModule, MaskService, IConfig } from 'ngx-mask';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateSharedModule } from './translate/translate.module';
import { LobbyComponent } from './lobby/lobby.component';
import { Angular5TimePickerModule } from 'angular5-time-picker'
import { TimepickerDirective } from 'angular5-time-picker';
import { SelectUserSelectComponent } from './select-user/select/select.component';
import { SearchComponent } from './advanced-search/search.component';
import { UserFiltersComponent } from './user-filters/filters.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FilterComponent } from './filter/filter.component';
import { PaymentConfigComponent } from './payment-config/payment-config.component';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { AsapBaseModule } from 'app/@core/lib/asap-base.module';
import { HomePlatformChangeComponent } from 'app/modules/shared/home-platform-change/home-platform-change.component';
import { DashboardCompaniesComponent } from './companies/dashboard-companies.component';
import { ItemsComponent } from 'app/modules/edital/items/items.component';
import { UploadModule } from 'app/modules/shared/upload/upload.module';

export var options: Partial<IConfig> | (() => Partial<IConfig>) = null;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY'
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM Y',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM Y'
  }
};

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatMenuModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatChipsModule,
    MatSelectModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatCheckboxModule,
    NouisliderModule,
    TagInputModule,
    RouterModule,
    ElasticModule,
    BannerModule,
    NgxMaskModule.forRoot(),
    TranslateModule,
    TranslateSharedModule,
    Angular5TimePickerModule,
    NgxMaskModule,
    CurrencyMaskModule,
    UploadModule,
    AsapBaseModule
  ],
  declarations: [
    FeedComponent,
    EmbedComponent,
    FeedCommentsComponent,
    FeedAnswerComponent,
    ModalContentComponent,
    ModalFeedComponent,
    FeedUserComponent,
    FeedVisitorComponent,
    SpinnerComponent,
    ListagemCursosComponent,
    ListagemEtapasCursosComponent,
    BannerComponent,
    CursosSugeridosComponent,
    ListagemCursosPaginaComponent,
    BannerPaginaComponent,
    ChatFirebaseComponent,
    SelectUserComponent,
    SelectUserComponentModal,
    SelectUserSelectComponent,
    SelectDialogComponent,
    LobbyComponent,
    SearchComponent,
    UserFiltersComponent,
    FilterComponent,
    PaymentConfigComponent,
    HomePlatformChangeComponent,
    DashboardCompaniesComponent,
    ItemsComponent

  ],
  exports: [
    NgxMaskModule,
    EmbedComponent,
    FeedComponent,
    FeedCommentsComponent,
    FeedAnswerComponent,
    ModalFeedComponent,
    ModalContentComponent,
    FeedUserComponent,
    FeedVisitorComponent,
    SpinnerComponent,
    ListagemCursosComponent,
    ListagemEtapasCursosComponent,
    CursosSugeridosComponent,
    ListagemCursosPaginaComponent,
    BannerPaginaComponent,
    ChatFirebaseComponent,
    SelectUserComponent,
    SelectUserComponentModal,
    SelectUserSelectComponent,
    SelectDialogComponent,
    TranslateSharedModule,
    LobbyComponent,
    Angular5TimePickerModule,
    TranslateModule,
    TranslateSharedModule,
    SearchComponent,
    UserFiltersComponent,
    FilterComponent,
    PaymentConfigComponent,
    HomePlatformChangeComponent,
    MatTooltipModule,
    AsapBaseModule,
    DashboardCompaniesComponent,
    ItemsComponent,
    UploadModule
  ],
  providers: [
    MaskService,
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ],
  entryComponents: [
    ModalFeedComponent,
    ModalContentComponent,
    SelectUserComponentModal,
    SelectDialogComponent
  ]
})

export class SharedModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts